import useGlobalLoader from '../../hooks/app/useGlobalLoader';
import Loader from '../loader';

function GlobalLoader() {
    const { loaders } = useGlobalLoader();

    const loading = loaders.length > 0;

    if (loading) {
        const titles = loaders.filter((item) => typeof item.title === 'string').map((item) => item.title) as string[];

        return (
            <Loader loading={loading} title={titles} />
        );
    }

    return null;
}

export default GlobalLoader;
